<template>
  <div class="row password-change">
    <v-container fill-height fluid grid-list-xl >
    </v-container>
  </div>
</template>


<script>
  import { createNamespacedHelpers, mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Login',
    computed: {
      ...mapGetters({ getTitleColorStore: 'app/getTitleColor' }),
      rules() {
        const rules1 = []
        if (this.min) {
          const rule = v => (v || '').length >= this.min || this.$t('security.rules.password_length', { count: this.min })
          rules1.push(rule)
        }
        if (!this.allowSpaces) {
          const rule = v => (v || '').indexOf(' ') < 0 || this.$t('validation_noSpaces')
          rules1.push(rule)
        }

        rules1.push(value => !!value || this.$t('validate.required_entry'))

        return rules1;
      }

    },
    methods: {
      ...mapActions({ setToken: 'app/setTokenWithExpiration', removeToken: 'app/removeToken' }),
      signIn() {
        var self = this;

        var isFormOk = this.$refs.form.validate();
        if (isFormOk) {
          var data = { Username: this.username, Password: this.password };
          this.$fetchDataPromise('/api/Auth/Login', data, null, true)
            .then(x => this.setToken(x))
            .then(function () {
              self.$router.push('/Portal/Security/PasswordChange');
            });
        } else {
          this.$displayInfo(this.$t('security.login_error'));
        }

      },

    },

    data: function () {
      return {
        //min: 3,
        required: true,
        allowSpaces: false,
        username: '',
        password: '',
        isFormOK: false,
        show1: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Security/Login.vue